import { render, staticRenderFns } from "./FaultAlarm.vue?vue&type=template&id=ba032fd8&scoped=true&"
import script from "./FaultAlarm.vue?vue&type=script&lang=js&"
export * from "./FaultAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba032fd8",
  null
  
)

export default component.exports